/* ============================================================
   ANDREW ADVISOR — Home · Lógica del formulario de contacto
   - Selector de país (default US) · arma teléfono E.164
   - Guarda el lead en Shopify (email a Andrew) + redirige a WhatsApp
   Espeja el mecanismo de davie-form.js, sin calificación ni Meta CAPI.
   ============================================================ */
(function () {
  'use strict';

  var form = document.getElementById('home-contact-form');

  /* ---- Selector de país (código telefónico) ---- */
  /* Banderas como IMAGEN, no como emoji.
     Los emoji de bandera (🇺🇸) son pares de "regional indicators" y
     Windows NO trae esos glifos: en Chrome de escritorio se ven como dos
     letras sueltas. En iOS/Android sí funcionan, por eso el bug pasaba
     desapercibido en el celular.
     Se usa el código ISO y se sirve la imagen; si fallara la carga, el
     alt deja el código visible en vez de un ícono roto. */
  var COUNTRIES = [
    { n: 'Estados Unidos', d: '1', c: 'us' },
    { n: 'Colombia', d: '57', c: 'co' },
    { n: 'México', d: '52', c: 'mx' },
    { n: 'Venezuela', d: '58', c: 've' },
    { n: 'Argentina', d: '54', c: 'ar' },
    { n: 'Perú', d: '51', c: 'pe' },
    { n: 'Ecuador', d: '593', c: 'ec' },
    { n: 'Chile', d: '56', c: 'cl' },
    { n: 'Rep. Dominicana', d: '1', c: 'do' },
    { n: 'Puerto Rico', d: '1', c: 'pr' },
    { n: 'Panamá', d: '507', c: 'pa' },
    { n: 'Costa Rica', d: '506', c: 'cr' },
    { n: 'Guatemala', d: '502', c: 'gt' },
    { n: 'Honduras', d: '504', c: 'hn' },
    { n: 'El Salvador', d: '503', c: 'sv' },
    { n: 'Nicaragua', d: '505', c: 'ni' },
    { n: 'Bolivia', d: '591', c: 'bo' },
    { n: 'Paraguay', d: '595', c: 'py' },
    { n: 'Uruguay', d: '598', c: 'uy' },
    { n: 'Brasil', d: '55', c: 'br' },
    { n: 'España', d: '34', c: 'es' },
    { n: 'Canadá', d: '1', c: 'ca' }
  ];

  function flagHtml(iso) {
    return '<img class="davie-phone__flagimg" src="https://flagcdn.com/w40/' + iso + '.png"' +
      ' srcset="https://flagcdn.com/w80/' + iso + '.png 2x"' +
      ' width="22" height="16" loading="lazy" decoding="async" alt="' + iso.toUpperCase() + '">';
  }
  var ccBtn = document.getElementById('home-cc-btn');
  var ccList = document.getElementById('home-cc-list');
  var ccFlag = document.getElementById('home-cc-flag');
  var ccDial = document.getElementById('home-cc-dial');
  var currentDial = '1';

  if (ccBtn && ccList) {
    // Bandera inicial (US): reemplaza el emoji que viene en el HTML
    if (ccFlag) ccFlag.innerHTML = flagHtml('us');

    var closeList = function () { ccList.hidden = true; ccBtn.setAttribute('aria-expanded', 'false'); };
    var openList = function () { ccList.hidden = false; ccBtn.setAttribute('aria-expanded', 'true'); };
    COUNTRIES.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'davie-phone__opt';
      li.setAttribute('role', 'option');
      li.innerHTML = flagHtml(c.c) + '<span class="davie-phone__optn">' + c.n + '</span><span class="davie-phone__optd">+' + c.d + '</span>';
      li.addEventListener('click', function () {
        currentDial = c.d; ccFlag.innerHTML = flagHtml(c.c); ccDial.textContent = '+' + c.d;
        closeList();
        var ph = document.getElementById('home-phone'); if (ph) ph.focus();
      });
      ccList.appendChild(li);
    });
    ccBtn.addEventListener('click', function (e) { e.stopPropagation(); if (ccList.hidden) openList(); else closeList(); });
    document.addEventListener('click', function (e) { if (!ccList.hidden && !ccList.contains(e.target) && e.target !== ccBtn) closeList(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeList(); });
  }

  if (!form) return;

  /* ---- helpers ---- */
  function val(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
  function digits(s) { return (s || '').replace(/\D/g, ''); }
  function fullPhone() { return '+' + currentDial + ' ' + val('home-phone'); }
  function phoneE164() { return '+' + currentDial + digits(val('home-phone')); }

  function buildBody() {
    var lines = [
      'Nuevo contacto — andrewadvisor.com',
      'Nombre: ' + val('home-name'),
      'Email: ' + val('home-email'),
      'Teléfono: ' + fullPhone(),
      'Interés: ' + val('home-interes')
    ];
    var m = val('home-message');
    if (m) lines.push('Mensaje: ' + m);
    return lines.join('\n');
  }

  /* ---- Canal elegido ---- */
  function contactMethod() {
    var el = document.querySelector('input[name="contact[Contacto preferido]"]:checked');
    return el ? el.value : 'WhatsApp';
  }

  /* Mismo mensaje para WhatsApp y SMS: el cliente no debería tener que
     escribir nada, solo apretar enviar. */
  function contactMessage() {
    var tpl = val('home-wa-msg') ||
      'Hola Andrew, soy {nombre}. Vi tu página y quiero conversar sobre bienes raíces en South Florida.';
    var greeting = tpl.replace('{nombre}', val('home-name'));
    var msg = greeting + '\n\nMe interesa: ' + val('home-interes');
    var extra = val('home-message');
    if (extra) msg += '\n' + extra;
    return msg;
  }

  function whatsappUrl() {
    var wa = digits(val('home-wa')) || '17864428485';
    return 'https://wa.me/' + wa + '?text=' + encodeURIComponent(contactMessage());
  }

  function smsUrl() {
    var num = digits(val('home-wa')) || '17864428485';
    // "?&body=" es el formato que entienden iOS y Android por igual
    return 'sms:+' + num + '?&body=' + encodeURIComponent(contactMessage());
  }

  /* ---- Cookies de Meta (para atribución si el visitante vino de un anuncio) ---- */
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : undefined;
  }

  /* ---- Envía el lead al Cloudflare Worker ----
     Es el mismo endpoint que usa la landing de Davie. El Worker se encarga
     de tres cosas: email a Andrew (Resend), guardado en la planilla, y
     evento a Meta.

     Va con source:'home' para que el Worker sepa qué email armar, y con
     qualified:false porque este formulario NO precalifica: es una captura
     general. El Worker solo manda el evento a Meta cuando qualified es
     true, así estas consultas no ensucian la optimización de la campaña
     de Davie, que se optimiza sobre leads precalificados.

     El envío es "fire and forget": si el Worker falla, el lead igual quedó
     guardado por el formulario nativo de Shopify y el usuario ya se fue a
     WhatsApp. Nunca bloquea el flujo. */
  function sendLead() {
    var capiUrl = val('home-capi');
    if (!capiUrl) return;

    var payload = {
      source: 'home',
      qualified: false,
      event_source_url: window.location.href,
      name: val('home-name'),
      email: val('home-email'),
      phone: fullPhone(),
      interes: val('home-interes'),
      message: val('home-message'),
      contact_pref: contactMethod(),
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc')
    };

    try {
      fetch(capiUrl, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (err) {}
  }

  function setSuccessText(title, text) {
    var s = document.getElementById('home-success');
    if (!s) return;
    var h = s.querySelector('h3');
    var p = s.querySelector('p');
    if (h && title) h.textContent = title;
    if (p && text) p.textContent = text;
  }

  /* Muestra SOLO el bloque pedido y esconde el resto: si no, con dos
     bloques de éxito en el DOM aparecerían los dos a la vez. */
  function showSuccess(targetId) {
    var s = document.getElementById(targetId || 'home-success');
    var fields = form.querySelector('.davie-form-fields');
    if (fields) fields.style.display = 'none';

    var blocks = form.querySelectorAll('.davie-form-success');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i] === s) continue;
      blocks[i].style.display = 'none';
      blocks[i].classList.remove('is-visible');
    }
    if (s) { s.style.display = ''; s.classList.add('is-visible'); }
  }

  /* ---- Opción "Llamada": copiar el número al portapapeles ---- */
  (function initCall() {
    function copiar(texto, onDone) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(onDone).catch(function () { fallback(texto, onDone); });
      } else {
        fallback(texto, onDone);
      }
    }
    function fallback(texto, onDone) {
      var ta = document.createElement('textarea');
      ta.value = texto;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      onDone();
    }
    ['home-call-copybtn', 'home-call-num'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('click', function () {
        var num = el.getAttribute('data-num') || '';
        copiar(num, function () {
          var prev = el.textContent;
          if (id === 'home-call-copybtn') {
            el.textContent = '¡Copiado!';
            setTimeout(function () { el.textContent = prev; }, 1800);
          } else {
            el.classList.add('is-copied');
            setTimeout(function () { el.classList.remove('is-copied'); }, 1800);
          }
        });
      });
    });
  })();

  /* ---- Envío ---- */
  var submitted = false;
  form.addEventListener('submit', function (e) {
    if (submitted) return;
    e.preventDefault();
    submitted = true;

    var phoneFull = document.getElementById('home-phone-full');
    if (phoneFull) phoneFull.value = fullPhone();
    var waLink = document.getElementById('home-wa-link');
    if (waLink) waLink.value = 'https://wa.me/' + digits(phoneE164());
    var bodyEl = document.getElementById('home-body');
    if (bodyEl) bodyEl.value = buildBody();

    // 1) Worker: email a Andrew (Resend) + planilla
    sendLead();

    // 2) Formulario nativo de Shopify: respaldo. Si el Worker se cae, el
    //    lead igual llega por el email de notificaciones de la tienda.
    var action = form.getAttribute('action') || '/contact';
    try {
      fetch(action, { method: 'POST', body: new FormData(form), keepalive: true, headers: { 'Accept': 'application/json' } }).catch(function () {});
    } catch (err) {}

    /* Redirección según el canal elegido.
       "Llamada" no se puede forzar desde el navegador, así que en vez de
       redirigir se muestra el número para copiar. */
    var method = contactMethod();
    if (method === 'Llamada') {
      showSuccess('home-success-call');
      return;
    }

    setSuccessText(val('home-redirect-title'), val('home-redirect-text'));
    showSuccess('home-success');
    var url = method === 'SMS' ? smsUrl() : whatsappUrl();
    setTimeout(function () { window.location.href = url; }, 700);
  });
})();
